import React, { useEffect } from 'react';

// import Head from 'next/head';

import Grid from '@material-ui/core/Grid';
import notfound from '../assets/images/notfound/notfound.gif';

export default function Notfound(props) {

    const setValue = props.setValue;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(false);
    }, [setValue]);

    return (
        <React.Fragment>
            <Grid container direction="row" justify="center" style={{ marginTop: "-2.3em", }}>
                <img alt="not found" src={notfound} style={{ width: "100%", maxWidth: "100%" }} />
            </Grid>
        </React.Fragment>
    )
}